export const SET_BUSINESS = 'SET_BUSINESS'
export const SET_BUSINESS_PERMISSION = 'SET_BUSINESS_PERMISSION'
export const CHECK_BUSINESS_PERMISSION = 'CHECK_BUSINESS_PERMISSION'
export const FALSE_BUSINESS_PERMISSION = 'FALSE_BUSINESS_PERMISSION'